import { NotificationInbox } from 'components/notification-inbox';

export default function NotificationInboxPage() {
  return <NotificationInbox />;
}
